import { createComponent } from "react-fela";
import { fluid } from "~/styleguide/utils";
import { gutters } from "~/styleguide";
import SummaryCard from "~/components/resource/summary/card";

export default function CardListing({
    resources,
    hasSidebar,
    type,
    eyebrow,
    layout = "grid",
    listing_image,
    extend
}) {
    return (
        <ResourceListing
            hasSidebar={hasSidebar}
            extend={extend}
            layout={layout}
        >
            {resources &&
                resources.length &&
                resources.map((resource, index) => {
                    return (
                        <SummaryCard
                            resource={resource}
                            key={index}
                            type={type}
                            eyebrow={eyebrow}
                            layout={layout}
                            listing_image={listing_image}
                            collectionLength={resources.length}
                        />
                    );
                })}
        </ResourceListing>
    );
}

const ResourceListing = createComponent(({ hasSidebar, layout }) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    extend: [
        {
            condition: hasSidebar,
            style: {
                flexBasis: "75%"
            }
        },
        {
            condition: layout === "carousel",
            style: {
                maxWidthTabletLandscape: {
                    flexWrap: "nowrap",
                    extend: [fluid("paddingH", gutters.default)]
                }
            }
        }
    ],
    maxWidthTabletLandscape: {
        justifyContent: "center"
    }
}));
